module.exports = __webpack_public_path__ + "static/media/qbstart.2b63f852.png";